import { http } from "./http";

export type PosCatalogSyncLogSummary = {
  scope: string;
  status: string;
  message: string | null;
  createdAt: string;
};

export type PosCatalogStatus = {
  ok: boolean;
  catalogImportMode: "midware" | "easy-retail";
  midwareConfigured: boolean;
  midwareBaseUrl: string | null;
  categoriesCount: number;
  productsCount: number;
  defaultSeedEnabled: boolean;
  deactivateMissingEnabled: boolean;
  lastSync: PosCatalogSyncLogSummary | null;
  lastMidwareSync: PosCatalogSyncLogSummary | null;
  lastEasyRetailSync: PosCatalogSyncLogSummary | null;
};

export type PosCatalogSyncResult = {
  ok: boolean;
  dryRun?: boolean;
  source?: "local" | "midware";
  note?: string;
  departmentsReceived?: number;
  productsReceived?: number;
  categoriesPrepared?: number;
  productsPrepared?: number;
  categoriesSynced?: number;
  productsSynced?: number;
  productsDeactivated?: number;
  categoriesCount?: number;
  productsCount?: number;
  sampleCategories?: Array<{ code: string; name: string }>;
  sampleProducts?: Array<{ code: string; name: string; unitPrice: number; categoryCode?: string; ean?: string | null }>;
  categoriesSample?: Array<{ code: string; name: string }>;
  productsSample?: Array<{ code: string; name: string; unitPrice: number; ean?: string | null }>;
};

export const posCatalogApi = {
  getStatus(token: string) {
    return http<PosCatalogStatus>("/pos/catalog/status", { method: "GET" }, token);
  },

  testMidware(token: string) {
    return http<{ ok: boolean; sessionCodePreview: string; departmentsReceived: number; productsReceived: number }>(
      "/pos/catalog/midware/test",
      { method: "GET" },
      token,
    );
  },

  sync(token: string, payload?: { dryRun?: boolean; deactivateMissing?: boolean }) {
    return http<PosCatalogSyncResult>("/pos/catalog/sync", { method: "POST", body: JSON.stringify(payload || {}) }, token);
  },
};
